exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.how-to[data-v-0271d428] {\n    white-space: pre-wrap;\n    background-color: #fff;\n    padding: 10px;\n}\n.table th[data-v-0271d428], .table td[data-v-0271d428] {\n    border-top: 0px\n}\n/*ボタンのスタイル*/\n.btn-primary[data-v-0271d428]:hover {\n    color: #fff !important;\n}\n/*スマホ用css*/\n@media screen and (max-width: 418px) {\n.font-size[data-v-0271d428]{\n        font-size:10px;\n}\n}\n", ""]);

// exports
